// extracted by mini-css-extract-plugin
module.exports = {"title":"QuestionLeft_title__5FQ97","body":"QuestionLeft_body__2MB9i","htmlContent":"QuestionLeft_htmlContent__2-FCc"};